import SENLogo from "@/assets/icons/SENLogo";
import LinkedIn from "@/assets/icons/LinkedIn";
import X from "@/assets/icons/X";
import Link from "next/link";
import classes from "./Footer.module.scss";
import BackToTop from "./BackToTop/BackToTop";

const topicLinks = [
  {
    title: "Investments",
    link: "/category/investments",
  },
  {
    title: "Carbon Markets",
    link: "/category/carbon-markets",
  },
  {
    title: "Clean Energy",
    link: "/category/clean-energy",
  },
  {
    title: "Policy & Regulation",
    link: "/category/policy-regulation",
  },
  {
    title: "Tech and Innovation",
    link: "/category/tech-and-innovation",
  },
  {
    title: "Coal",
    link: "/category/coal",
  },
  {
    title: "Steel",
    link: "/category/steel",
  }
];

const topicsMiddleSection = [
  {
    title: "Oil & Gas",
    link: "/category/oil-and-gas",
  },
  {
    title: "Transition Finance",
    link: "/category/transition-finance",
  },
  {
    title: "ESG",
    link: "/category/esg",
  },
  {
    title: "Corporates",
    link: "/category/corporates",
  },
  {
    title: "Environment",
    link: "/category/environment",
  },
  {
    title: "Reports",
    link: "/category/report",
  },
  {
    title: "Transport",
    link: "/category/transport",
  }
];

const companyLinks = [
  {
    title: "About Us",
    link: "/about-us",
  },
  {
    title: "Contact Us",
    link: "/contact",
  },
  {
    title: "Privacy Policy",
    link: "/privacy-policy",
  },
  {
    title: "Terms & Conditions",
    link: "/terms-and-conditions",
  },
];

const Footer = () => {
  return (
    <footer className={classes["footer"]}>
      <div className={classes["container"]}>
        {/* Logo */}
        <div className={classes["top-container"]}>
          <div className={classes["logo"]}>
            <SENLogo />
          </div>

          <div className={classes["tagline"]}>
            <BackToTop />

            <p className={classes["owned-by"]}>
              Owned By{" "}
              <Link
                href={"https://www.sustainabilityeconomics.ai/"}
                rel="noopener noreferrer"
                target="_blank"
              >
                Sustainability Economics
              </Link>{" "}
            </p>
          </div>
        </div>

        <div className={classes["separator"]}></div>

        {/* Menu Wrapper */}
        <div className={classes["menuWrapper"]}>
          {/* Quick Links Section */}

          <div>
            <div className={classes["menuHeading-left"]}>Topics</div>
            <div className={classes["separator"]}></div>

            <div className={classes["topics-company-section"]}>
              <div className={classes["menuSection"]}>
                <div className={classes["menuColumn-left"]}>
                  <ul>
                    {topicLinks.map(({ title, link }) => (
                      <li key={title}>
                        <Link href={link}>{title}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className={classes["menuSection"]}>
                <div className={classes["menuColumn-middle"]}>
                  <ul>
                    {topicsMiddleSection.map(({ title, link }) => (
                      <li key={title}>
                        <Link href={link}>{title}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Company Section */}
          <div className={`${classes.menuSection}`}>
            <div className={classes["menuHeading-right"]}>Company</div>
            <div className={classes["separator"]}></div>
            <div className={classes["menuColumn-right"]}>
              <ul>
                {companyLinks.map(({ title, link }) => (
                  <li key={title}>
                    <Link
                      href={link}
                      target={
                        title === "Privacy Policy" ||
                        title === "Terms & Conditions"
                          ? "_blank"
                          : "_self"
                      }
                      rel={
                        title === "Privacy Policy" ||
                        title === "Terms & Conditions"
                          ? "noopener noreferrer"
                          : ""
                      }
                    >
                      {title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className={classes["separator"]}></div>

        <div className={classes["bottom-container"]}>
          <div className={classes["socialIcons"]}>
            <Link
              href={
                "https://www.linkedin.com/company/sustainability-economics-news/"
              }
              rel="noopener noreferrer"
              target="_blank"
            >
              <LinkedIn />
            </Link>

            <Link
              href={"https://x.com/SE_News_Live"}
              rel="noopener noreferrer"
              target="_blank"
            >
              <X />
            </Link>
          </div>

          <p className={classes["copyright"]}>
            © {new Date().getFullYear()}{" "}
            <Link
              href={"https://www.sustainabilityeconomics.ai/"}
              rel="noopener noreferrer"
              target="_blank"
            >
              Sustainability Economics Pte Ltd.
            </Link>{" "}
            All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
